import { render, staticRenderFns } from "./aboutIntroduce.vue?vue&type=template&id=39bc46a6&scoped=true"
import script from "./aboutIntroduce.vue?vue&type=script&lang=js"
export * from "./aboutIntroduce.vue?vue&type=script&lang=js"
import style0 from "./aboutIntroduce.vue?vue&type=style&index=0&id=39bc46a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc46a6",
  null
  
)

export default component.exports